import { useDispatch, useSelector } from 'react-redux';
import { addFields, addFilter, getRows } from 'features/GridSlice';
import { getFiltersServerFormat } from 'utils/filters';
import { selectView } from 'features/ViewsSlice';

const useFilters = () => {
  const { columnPicker } = useSelector((state: any) => state.columnPicker);
  const { filters } = useSelector((state: any) => state.grid);
  const dispatch = useDispatch<any>();

  const isSelected = (item: string, filterId: string) => {
    const column = columnPicker.find((item: any) => item.name === filterId);
    const values = filters[filterId]?.value.split(',')
    const choice = column?.choices.find((choice: any) => choice.label.toLowerCase() === item.toLowerCase())
    return values?.includes(choice?.name.toString())
  }

  const handleFiltersOnClick = (filterId: string, fieldId: string, page?: string, findValue?: string) => {
    dispatch(selectView(null));

    const selected = columnPicker.find((item: any) => item.name === filterId);
    if (!!selected) {
      const { filter_type: filterType } = selected;
      let values;
      let filter;
      if (filterType === 'stringAndNumber') {
        values = selected.choices.find((item: any) => item.label.toLowerCase() === 'full match');
        const updatedValue = { ...values, value: fieldId };
        filter = getFiltersServerFormat(filterType, selected, updatedValue);
      } else if (filterType === 'radio') {
        values = selected.choices.find(
          (item: any) => item.name.toLowerCase() === (findValue !== undefined ? findValue : 'true')
        );
        filter = getFiltersServerFormat(filterType, selected, values, filterType);
      } else {
        const selectedValue = selected.choices.find((item: any) => item.label.toLowerCase() === fieldId.toLowerCase())?.name.toString();
        let selectedValues = filters[filterId]?.value.split(',') || [];
        if (selectedValues.includes(selectedValue)) {
          selectedValues = selectedValues.filter((val: string) => val !== selectedValue);
        } else {
          selectedValues = [...selectedValues, selectedValue];
        }
        filter = getFiltersServerFormat(filterType, selected, selectedValues);
      }

      dispatch(addFilter(filter));
      dispatch(addFields([selected.name]));
      dispatch(getRows());
    }
  };

  return { handleFiltersOnClick, isSelected };
};

export default useFilters;
